import { useState, useEffect, useRef } from 'react'
import { makeStyles, Grid, Paper, Container, Avatar } from '@material-ui/core'
import useTranslate from '../i18n/useTranslate'
import ConnectLineForm from '../component/um/line/ConnectLineForm'
import { encryption } from '../utilities/encryption'
import useLineLogin, { ConnectLineType } from '../services/um/useLineLogin'
import Dialog, { DialogType } from '../control/dialog/dialog'
import CheckIcon from '@material-ui/icons/Check'
declare global {
    interface Window {
        liff: any
    }
}

const liff = window.liff

function ConnectLine() {
    const classes = useStyles()
    const translate = useTranslate()
    const [showPassword, setShowPassword] = useState(false)
    const { postLineLogin } = useLineLogin()
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    useEffect(() => {
        async function initLift() {
            await liff.init({ liffId: process.env.REACT_APP_LIFF_ID })
        }
        initLift()
    }, [])

    const onSubmit = async (value: ConnectLineType) => {
        const profile = await liff.getProfile()
        const result = await postLineLogin({
            username: value.username,
            password: encryption(value.password),
            salt: Buffer.from(value.password).toString('base64'),
            lineID: profile.userId,
        })

        if (result.message === 'incorrect') {
            setConfigDialog({
                title: '',
                content: `${translate.get('UM.LINE.MESSAGE.INCORRECT')}`,
                type: 'alert-message',
            })
            dialogTwoRef.current?.openDialog()
        }

        if (result.message === 'success') {
            setConfigDialog({
                title: '',
                content: `${translate.get('UM.LINE.MESSAGE.SUCCESS')}`,
                type: 'alert-message',
            })
            dialogTwoRef.current?.openDialog()

            ///ปิด broweser
            liff.closeWindow()
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const onHandelShowPassword = () => {
        setShowPassword(!showPassword)
    }

    return (
        <Container maxWidth="lg">
            <Grid container justify="center" alignContent="center" className={classes.root}>
                <Grid item xs={12} md={8} lg={6} className={classes.item}>
                    <Paper className={classes.paper}>
                        <Grid container className={classes.container}>
                            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.gridTypography}>
                                <div className={classes.typographyWrap}>
                                    <img
                                        src={process.env.PUBLIC_URL + '/img/Chulalongkorn_University_Alt_Logo.svg.png'}
                                        width="50%"
                                        height="100%"
                                        alt="default"
                                        className={classes.imageTypography}
                                    />

                                    <Avatar className={classes.checkIcon}>
                                        <CheckIcon fontSize="small" />
                                    </Avatar>

                                    <div className={classes.typography}>
                                        {`${translate.get('UM.LINE.CONNECT_LINE_FORM.HEADER')}`}
                                    </div>

                                    <div className={classes.dash} />
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <ConnectLineForm
                                    onSubmit={onSubmit}
                                    showPassword={showPassword}
                                    onHandelShowPassword={onHandelShowPassword}
                                />
                            </Grid>
                            <Dialog onRef={onRefDialogTwo} {...configDialog} />
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
    },
    item: {
        [theme.breakpoints.up('md')]: {
            padding: '56px',
        },
    },
    container: {
        padding: '2rem',
        [theme.breakpoints.down('sm')]: {
            padding: '0',
        },
    },
    paper: {
        backgroundColor: '#F7F7F7',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    gridTypography: {
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: theme.spacing(0, 2),

        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(0),
            padding: '0',
        },
    },
    typography: {
        fontWeight: 'bold',
        color: '#1bb71f',
        fontFamily: 'prompt',
        fontSize: '30px',
        backgroundColor: '#F7F7F7',
        zIndex: 1,
    },
    typographyWrap: {
        width: 320,
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        margin: theme.spacing(3, 0),
        justifyContent: 'space-between',

        [theme.breakpoints.down('xs')]: {
            width: 150,
        },
    },
    imageTypography: {
        backgroundColor: '#F7F7F7',
        zIndex: 1,
    },
    checkIcon: {
        zIndex: 1,
        width: 24,
        height: 24,
        color: 'white',
        borderRadius: '50%',
        backgroundColor: '#db5f8e',
    },
    dash: {
        top: '50%',
        width: '100%',
        position: 'absolute',
        borderBottom: '3px dashed #db5f8e',
    },
}))

export default ConnectLine
